<template>
  <div id="base-file-uploader" class="upload-drop-zone">
    <span class="upload-text">{{ $t('app.dropFile') }}</span>
    <input
      id="base-file-input"
      :multiple="multiple"
      type="file"
      ref="file"
      class="input-hidden"
      :required="required ? true : false"
      @input="handleInput"
      @onChange="handleInput"
    >
  </div>
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    classNames: {
        type: String,
        default: ""
    },
    required: {
        type: Boolean,
        default: false
    },
    multiple: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      fileName: "Drop file here"
    }
  },
  methods: {
    handleInput (e) {
      this.fileName = this.$refs.file.files[0].name
      if(this.multiple === true) {
        this.$emit('input', this.$refs.file.files)
      } else {
        this.$emit('input', this.$refs.file.files[0])
      }
    }
  },
};
</script>

<style lang="scss">

#base-file-uploader {
  display: flex;
  justify-content: center;
  background: #F0F2F8;
  border-style: dashed;
  border-color: #F0F2F8;
  border-width: initial;
  line-height: 40px;
  width: 100%;

  .input-hidden {
    width: 100%;
    opacity: 0;
  }

  .upload-text {
    position: absolute;
  }

}

</style>


// WEBPACK FOOTER //
// src/components/shared/inputs/BaseFileUploader.vue